import { Route, Routes } from "react-router-dom";
import BlogPage from "../Pages/BlogPage";
import HomePage from "../Pages/HomePage";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/blog-yazilari/*" element={<BlogPage />} />
    </Routes>
  );
};

export default AppRoutes;
